// store/atoms.ts
import { atomWithStorage } from 'jotai/utils';
import { atom } from 'jotai';

export const userAtom = atomWithStorage<any | undefined>('user', undefined);
export const loadingAtom = atom<boolean>(false);
export const messageAtom = atom<{ message: string; type: 'success' | 'error' } | null>(null);
